export function toBigInt(value: unknown): bigint {
	if (typeof value === 'bigint') {
		return value
	}

	if (typeof value === 'string') {
		try {
			return BigInt(value)
		} catch {
			return 0n
		}
	}

	if (typeof value === 'number') {
		if (!Number.isFinite(value)) {
			return 0n
		}
		return BigInt(Math.trunc(value))
	}

	return 0n
}

// Min function to compare big integers
export function minBigInt(a: bigint, b: bigint): bigint {
	return a < b ? a : b
}

// Max function to compare big integers
export function maxBigInt(a: bigint, b: bigint): bigint {
	return a > b ? a : b
}
